// extracted by mini-css-extract-plugin
export default {"splash":"splash_splash__mMsSZ","lottie":"splash_lottie__uLCVT","text":"splash_text__anHH0","bar":"splash_bar__MZjvH","init":"splash_init__6B6DD","hide":"splash_hide__dxXAF"};